export default "<style>\n  \n  admin-ui\n  {\n\n  }\n\n</style>\n\n<admin-ui>\n\n</admin-ui>";